import { Button, Card, Stack, styled } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import type { Size } from "../../types";

interface AppLoadingButtonProps {
    spinnerColor?: string;
    sx?: SxProps<Theme>;
}

export const AppLoadingButton = styled(Button)<AppLoadingButtonProps>(({ sx, spinnerColor }) => ({
    "& .MuiCircularProgress-root": { color: spinnerColor ?? `#3A73FF` },
    letterSpacing: `.05em`,
    fontSize: 16,
    ...(sx as Record<string, string | number>),
}));

interface LoginButtonProps {
    secondary?: boolean;
}

export const LoginButton = styled(Button)<LoginButtonProps>(({ theme, secondary }) => ({
    background: secondary ? `none` : theme.palette.account.accent,
    border: secondary ? `2px solid ${theme.palette.account.accent}` : `none`,
    letterSpacing: `.05em`,
    fontSize: 16,
    display: `flex`,
    alignItems: `center`,
    justifyContent: `center`,
}));

export const accountInputBoxCSS = {
    "& div, input, label, fieldset, legend": {
        border: `none`,
    },
    "& input": {
        background: `#F5F4F2`,
        border: `1px solid #EFEFEF`,
        borderRadius: `4px`,
        boxShadow: `0 0 0 50px #F5F4F2 inset !important`,
        paddingRight: `25px`,
    },
    "& label": {
        color: `#666`,
    },
};

interface SignInCardProps {
    size?: Size | string;
    wide?: boolean;
    lastPage?: boolean;
    topSmall?: boolean;
    padding?: string;
    sx?: SxProps<Theme>;
}

export const SignInCard = styled(Card)<SignInCardProps>(
    ({ theme, size, wide, lastPage, sx = {}, topSmall, padding }) => ({
        ...(size === `small` ? { border: `none` } : {}),
        display: `flex`,
        flexDirection: `column`,
        alignSelf: `center`,
        width: `100%`,
        borderRadius: 4,
        padding:
            padding || (size === `small` ? `${theme.spacing(4)} 10px ${theme.spacing(4)}` : `${theme.spacing(4)} 90px`),
        ...(topSmall ? { paddingTop: `15px` } : {}),
        ...(lastPage ? { paddingTop: 62, paddingBottom: 62 } : {}),
        gap: theme.spacing(2),
        margin: `auto`,
        [theme.breakpoints.up(`sm`)]: {
            maxWidth: wide ? `750px` : `600px`,
        },
        ...(sx as Record<string, string | number>),
    })
);

interface SignInContainerProps {
    size?: Size | string;
}

export const SignInContainer = styled(Stack)<SignInContainerProps>(({ size }) => ({
    padding: size === `small` ? 0 : `0 20px 10px`,
    ...(size === `small` ? { boxShadow: `none`, border: `none`, background: `none` } : {}),
    marginTop: `30px`,
}));
